import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './variables.css';
import App from './App';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { config } from './Firebase';

firebase.initializeApp(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />

);
